import { render, staticRenderFns } from "./TableFiveGames.vue?vue&type=template&id=9116af22&scoped=true&"
import script from "./TableFiveGames.vue?vue&type=script&lang=js&"
export * from "./TableFiveGames.vue?vue&type=script&lang=js&"
import style0 from "./TableFiveGames.vue?vue&type=style&index=0&id=9116af22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9116af22",
  null
  
)

export default component.exports